/**
 * Make the native iOS shell follow the system text size (Dynamic Type).
 *
 * A WKWebView does not scale page text by itself. `html.dynamic-type` (packages/ui/src/theme.css) sets the root font to
 * `-apple-system-body`, and every Tailwind size is rem, so the whole UI follows it. It is gated on the Capacitor iOS
 * platform and nothing else: desktop Safari also understands `-apple-system-body` but gives 13px there, which would
 * shrink the web build. Android is a separate slice (docs/proposals/larger-text-support.md).
 */
export function applyDynamicType(win: Pick<Window, 'document'> & { Capacitor?: { getPlatform?: () => string } }): boolean {
  const on = win.Capacitor?.getPlatform?.() === 'ios';
  if (on) win.document.documentElement.classList.add('dynamic-type');
  return on;
}
